import { Component, OnInit, Inject } from "@angular/core";
import { TranslateService } from "@ngstack/translate";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";

import { IRoom } from "src/app/interfaces/room";
import { IRoomType } from "src/app/interfaces/roomType";
import { StaticValueService } from "src/app/services/http/business/staticValue/static-value.service";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { RoomService } from "src/app/services/http/business/room/room.service";
import { SnackBarService } from "src/app/services/common/snackBar.service";
import { SoundEnum } from "src/app/enums/sound.enum";
import { ErrorsService } from "src/app/services/common/errors.service";
import { IError } from "src/app/interfaces/error.interface";

@Component({
  selector: "app-room-entry",
  templateUrl: "./room-entry.component.html",
  styleUrls: ["./room-entry.component.css"]
})
export class RoomEntryComponent implements OnInit {
  param: any;
  errorList: IError[] = [];
  errObject: any;
  form: FormGroup;
  errors = new Array();
  roomTypeList: IRoomType;

  constructor(
    private fb: FormBuilder,
    private roomService: RoomService,
    private snackBar: SnackBarService,
    private errorService: ErrorsService,
    private translate: TranslateService,
    private staticValueService: StaticValueService,
    private dialogRef: MatDialogRef<RoomEntryComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IRoom
  ) {
  }

  ngOnInit() {
    this.createForm();
    this.getRoomListType();
  }

  getRoomListType() {
    this.staticValueService.roomType(false, 0, 0).subscribe(res => {
      this.roomTypeList = res;
    });
  }

  createForm() {
    this.form = this.fb.group({
      Title: [
        this.data && this.data.Title ? this.data.Title : null,
        Validators.compose([
          Validators.required,
          Validators.minLength(1),
          Validators.maxLength(50)
        ])
      ],
      Floor: [
        this.data && this.data.Floor ? this.data.Floor : null,
        Validators.compose([
          Validators.required,
          Validators.min(-50),
          Validators.max(250)
        ])
      ],
      Capacity: [
        this.data && this.data.Capacity ? this.data.Capacity : null,
        Validators.compose([
          Validators.required,
          Validators.min(1),
          Validators.max(600)
        ])
      ],
      RoomTypeId: [
        this.data && this.data.RoomTypeId
          ? this.data.RoomTypeId.toString()
          : null,
        Validators.compose([Validators.required])
      ],
      IsVirtual: [
        this.data && this.data.IsVirtual ? this.data.IsVirtual : false,
        Validators.compose([Validators.required])
      ],
      Priority: [
        this.data && this.data.Priority ? this.data.Priority : null,
        Validators.compose([
          Validators.required,
          Validators.min(1),
          Validators.max(2147483647)
        ])
      ],
      Id: [this.data && this.data.Id ? this.data.Id : 0]
    });
  }

  submit(data: IRoom) {
    this.errors = new Array();
    if (this.data) {
      this.roomService.edit(data).subscribe(
        () => {
          this.onClose();

          this.snackBar.OpenSnackBar(
            this.translate.get("success.registration"),
            "ok",
            5000,
            SoundEnum.beep
          );
        },
        err => {
          // this.errObject = this.errorService.getError(err);
          // this.param = this.errorService.objectError(this.errObject);
          // this.errors = this.errorService.returnError(err);
          this.errorList = this.errorService.getErrorList(err.error);
        }
      );
    } else {
      this.roomService.add(data).subscribe(
        () => {
          this.form.controls['Title'].reset();
          this.form.controls['Floor'].reset();
          this.form.controls['Capacity'].reset();
          this.form.controls['RoomTypeId'].reset();
          this.form.controls['RoomTypeId'].setValue(false);
          this.snackBar.OpenSnackBar(
            this.translate.get("success.registration"),
            "ok",
            5000,
            SoundEnum.beep
          );
        },
        err => {
          // this.errObject = this.errorService.getError(err);
          // this.param = this.errorService.objectError(this.errObject);
          // this.errors = this.errorService.returnError(err);
          this.errorList = this.errorService.getErrorList(err.error);
        }
      );
    }
  }

  onClose() {
    this.dialogRef.close();
  }
}
